import { render, staticRenderFns } from "./IndexProductBody.vue?vue&type=template&id=087a4626&scoped=true"
import script from "./IndexProductBody.vue?vue&type=script&lang=js"
export * from "./IndexProductBody.vue?vue&type=script&lang=js"
import style0 from "./IndexProductBody.vue?vue&type=style&index=0&id=087a4626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a4626",
  null
  
)

export default component.exports